import { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import { LuCircleAlert } from "react-icons/lu";
import { useDarkMode } from "../useDarkMode";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function IntegrityFailureModal({ open }) {
  const navigate = useNavigate();
  const isDarkMode = useDarkMode();

  const onBack = () => {
    navigate(-1);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
      }}
      aria-labelledby="integrity-failure-title"
      sx={{
        "& .MuiPaper-root": {
          bgcolor: isDarkMode ? "#26282C" : "#FFFFFF",
          borderRadius: "24px",
          boxShadow: isDarkMode
            ? "0px 8px 24px rgba(0,0,0,0.4)"
            : "0px 8px 24px rgba(0,0,0,0.12)",
          maxWidth: "500px",
          width: "100%",
        },
      }}
    >
      <Box sx={{ pb: "44px", px: "36px", pt: "32px" }}>
        <Box
          aria-hidden="true"
          sx={{
            width: 56,
            height: 56,
            border: "1px solid #FCE7DE",
            borderRadius: "14px",
            bgcolor: isDarkMode ? "#4A3800" : "#FEF8F4",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <LuCircleAlert size={24} color="#EA580C" />
        </Box>

        <Typography
          id="integrity-failure-title"
          component="h2"
          sx={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: "36px",
            color: isDarkMode ? "#FFF" : "#111827",
            mb: 1.5,
          }}
        >
          File Reassigned
        </Typography>

        <Typography
          sx={{
            fontSize: "17px",
            fontWeight: 500,
            lineHeight: 1.5,
            color: isDarkMode ? "#878D98" : "#717182",
            mb: 4,
          }}
        >
          Our system detected unresolved intentional quality-check inserts and
          other indicators suggesting that the submitted output does not
          accurately reflect the source audio. As a result, this file does not
          pass expected quality standards and has been reassigned to a
          different editor.
          <br />
          <br />
          Submitted files with unresolved quality concerns may be referred for
          admin review, and confirmed issues may affect quality assessment and
          invoice eligibility.
          <br />
          <br />
          If you believe this notification was triggered in error and are
          confident that your submitted file accurately reflects the source
          audio and meets quality standards, please contact your SWC.
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={onBack}
          sx={{
            bgcolor: "#0659F9",
            borderRadius: "9999px",
            color: "#FFF",
            fontSize: "18px",
            fontWeight: 500,
            height: "56px",
            textTransform: "none",
            "&:hover": {
              bgcolor: "#0041CC",
            },
          }}
        >
          Back to Dashboard
        </Button>
      </Box>
    </Dialog>
  );
}
